// extracted by mini-css-extract-plugin
export default {"root":"IconSearch_root__WSfIl"};